import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { getWidgedsBySize } from "api/Dashboard";


export const useWidgetBySize = (size?: string) => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['widgetsBySize'],
        () => {
            return getWidgedsBySize({ size: size });
        }, {
        onError(error: any) {
            toast.error(error?.response?.data?.message || 'Something went wrong. Please try again later.');
        },
    }
    );

    return {
        data,
        isLoading,
    };
};
